import { serviceInspectionUrl } from './urls';
import { createAxios } from './apiClient';

export const getAssistantData = (inspectionId: string) => {
  const instance = createAxios();
  return instance.get(serviceInspectionUrl() + encodeURIComponent(inspectionId)).then((response) => {
    return response.data.data.item;
  });
};



// WEBPACK FOOTER //
// ./src/shared/api/InspectionApi.tsx